import React, { useCallback, useEffect } from 'react'
import { isEmpty } from 'lodash'

import {MultiSelectWithPreview} from '@ublique/components/MultiSelect'
import MultiSelect from '@ublique/components/MultiSelect'
import { AddFilled20, SubtractAlt20 } from '@carbon/icons-react'

import { getFormItem } from '../helpers'

const PermissionBlock = ({
 t,
 onAdd,
 onRemove,
 firstBlock,
 onFormChange,
 scenarioItems,
 values,
 errors,
 showAddButton
}) => {
  const { scenarioTypes, minePermissions, otherPermissions } = values

  const itemToString = (item) => (item ? t(item.label) : '')

  const onChange = useCallback(
    (value) => {
      onFormChange(value)
    },
    [onFormChange]
  )

  useEffect(() => {
    if (isEmpty(scenarioItems) && isEmpty(scenarioTypes)) {
      onRemove()
    }
  }, [scenarioItems])

  return (
    <>
      <div className='header-btn'>
        <h6>{t('ScenarioManagement.Permissions')}</h6>
        {firstBlock && showAddButton && (
          <span className='handle-scenario-btn' onClick={onAdd}>
          <AddFilled20/>
        </span>
        )}
        {!firstBlock && (
          <span className='handle-scenario-btn' onClick={onRemove}>
          <SubtractAlt20/>
        </span>
        )}
      </div>
      <div className='form-block'>
        <MultiSelectWithPreview
          id='scenarioType'
          preview
          useTitleInItem={false}
          initialSelectedItems={!isEmpty(scenarioTypes) ? scenarioTypes : []}
          titleText={t('ScenarioManagement.ScenarioType')}
          label={t('ScenarioManagement.ScenarioType')}
          name='fields'
          value={scenarioTypes}
          onChange={(items) =>
            onChange({ scenarioTypes: items.selectedItems || items})
          }
          items={scenarioItems.map((field) => ({
            label: t(`Wizard:${field}`),
            value: field
          }))}
          itemToString={itemToString}
        />
        <div className='two-cols'>
          <MultiSelect
            id='permissions_mine'
            useTitleInItem={false}
            initialSelectedItems={
              !isEmpty(minePermissions) ? minePermissions : []
            }
            titleText={t('ScenarioManagement.OwnScenarios')}
            label={t('ScenarioManagement.OwnScenarios')}
            name='minePermissions'
            value={minePermissions}
            onChange={({ selectedItems }) =>
              onChange({ minePermissions: selectedItems })
            }
            items={[getFormItem('all')]}
            itemToString={itemToString}
          />

          <MultiSelect
            id='permissions_others'
            useTitleInItem={false}
            initialSelectedItems={
              !isEmpty(otherPermissions) ? otherPermissions : []
            }
            titleText={t('ScenarioManagement.OthersScenarios')}
            label={t('ScenarioManagement.OthersScenarios')}
            name='otherPermissions'
            value={otherPermissions}
            onChange={({ selectedItems }) =>
              onChange({ otherPermissions: selectedItems })
            }
            items={[getFormItem('read')]}
            itemToString={itemToString}
          />
        </div>
        {errors && (
          <p className='invalid-text'>{t(`ScenarioManagement.${errors}`)}</p>
        )}
      </div>
    </>
  )
}

export default PermissionBlock
